<template>
  <FilterPopper v-model:show="isOpen">
    <template #default="{ menuOpen }">
      <BaseFilterButton
        :name="'Image Tags'"
        :active="isActive"
        :tagValue="tagValue"
        :menuOpen="menuOpen"
      />
    </template>
    <template #popper>
      <div class="filter-settings scrollbar">
        <Transition name="fade" mode="out-in">
          <div v-if="internalTags && internalTags.length > 0">
            <div v-for="(tag, i) in internalTags" :key="i" class="filter-settings__row">
              <input
                :id="`annotationTagFilter-tag-${i}`"
                v-model="selectedTags"
                type="checkbox"
                :name="`${tag.name}-${i}`"
                :value="tag"
              >
              <label :for="`${tag.name}-${i}`">{{ tag.name }}</label><br>
            </div>
          </div>
          <div v-else-if="internalTags">
            No image tag
          </div>
          <div v-else>
            <v-skeleton-loader
              type="list-item"
              theme="primary"
              color="transparent"
            />
            <v-skeleton-loader
              type="list-item"
              theme="primary"
              color="transparent"
            />
          </div>
        </Transition>
      </div>
      <div class="filter-footer">
        <button :disabled="!isActive" class="button-text clear-button" @click="clearSelection">Clear Selection</button>
      </div>
    </template>
  </FilterPopper>
</template>

<script>
import FilterPopper from '@/components/FilterPopper.vue';
import BaseFilterButton from '@/components/BaseFilterButton.vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';

export default {
  name: "AnnotationTagFilter",
  components: {
    FilterPopper,
    BaseFilterButton,
  },
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    dataset: {
      type: Object,
      default: () => {},
    },
    invert: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'update:modelValue',
  ],
  data() {
    return {
      isOpen: false,
      selectedTags: [],
      internalTags: null,
    };
  },
  computed: {
    isActive() {
      return this.selectedTags.length > 0;
    },
    tagValue() {
      return this.selectedTags.length.toString();
    },
    currentDataset() {
      return this.$store.state.datasets.currentDataset;
    },
  },
  watch: {
    modelValue(newVal) {
      this.selectedTags = newVal;
    },
    selectedTags() {
      this.updateFilters();
    },
    isOpen(isOpen) {
      if (isOpen) {
        const dataConnect = new DatastoreConnect();
        dataConnect.listTagsForDataset({ dataset_id: this.dataset.id })
          .then((resp) => {
            if (resp.error) {
              throw resp.error;
            }
            this.internalTags = resp.result;
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    currentDataset() {
      this.internalTags = null;
      this.selectedTags = [];
    },
  },
  methods: {
    updateFilters() {
      this.$emit('update:modelValue', this.selectedTags);
    },
    clearSelection() {
      this.selectedTags = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-settings {
  display: flex;
  flex-direction: column;
  padding: 8px;
  border-radius: inherit;
  gap: 6px;
  min-width: 200px;
  overflow: auto;

  &__row {
      display: flex;
      align-items: center;
  }

  &__row + &__row {
    margin-top: 5px;
  }

  & input[type=checkbox] {
      margin-right: 12px;
  }
}

.filter-settings-extra {
  border-top: 1px solid rgba(140, 140, 140, 0.375);
  border-radius: 0;
}

.filter-footer {
min-height: 38px;
width: 100%;
border-top: 1px solid rgba(140,140,140,0.375);
padding: 8px;
text-align: center;

.clear-button {
    text-align: center;
    @include themify() {
    color: themed('color-danger');
    }

    &[disabled] {
    @include themify() {
        color: themed('color-disabled');
    }
    }
}
}
</style>
